<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/obeP8K/tc-custom/cover.jpeg?1663929383498?1704425338058" alt="This image is the cover for the book Masters of the Vortex, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Masters of the Vortex, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>A churning nuclear fireball, appearing out of nowhere, bringing utter destruction--and countless numbers of them were menacing planets throughout the Galaxy! "Storm" Cloud, nucleonic genius, set out in his spaceship Vortex Blaster to track and destroy the mysterious vortices--and embarked on a saga of adventure, discovery and conflict among the far stars that could have been told only by the incomparable "Doc" Smith. (Goodreads)</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        E. E. Smith
      </h2>
      
      <p class="authorDescription body article">Edward Elmer Smith (May 2, 1890 – August 31, 1965), publishing as E. E. Smith, Ph.D. and later as E. E. "Doc" Smith, was an American food engineer (specializing in doughnut and pastry mixes) and science-fiction author, best known for the Lensman and Skylark series. He is sometimes called the father of space opera.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?78866862